import { Reveal, SectionHeading } from '../Reveal';
import { WHY_US } from '../../data/content';

const WhyUs = () => (
  <section className="bg-white py-24 md:py-32" data-testid="why-us-section">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <SectionHeading
        index="08"
        overline="Why CareerWithRaaj"
        title="Not Just Another Education Consultancy"
        description="Career Guidance + Career Planning + Skill Development — one platform for your entire journey."
      />

      <div className="mt-16 border-t border-line">
        {WHY_US.map((item, i) => (
          <Reveal key={item.title} delay={0.05 * i}>
            <div
              className="group grid gap-3 border-b border-line py-8 transition-colors duration-300 hover:bg-mist md:grid-cols-12 md:items-center md:gap-8 md:px-6"
              data-testid={`why-us-item-${i + 1}`}
            >
              <span className="font-display text-sm font-bold text-coral md:col-span-1">{String(i + 1).padStart(2, '0')}</span>
              <h3 className="font-display text-xl font-semibold text-navy transition-colors duration-300 group-hover:text-coral md:col-span-4 md:text-2xl">
                {item.title}
              </h3>
              <p className="text-sm leading-relaxed text-slate-600 md:col-span-7 md:text-base">{item.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default WhyUs;
